'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('thingsboard.directives.circularProgress', []).directive('tbCircularProgress', CircularProgress).name;

/* eslint-disable angular/angularelement */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function CircularProgress($compile) {

    var linker = function linker(scope, element) {

        var circularProgressElement = angular.element('<md-progress-circular style="margin: auto;" md-mode="indeterminate" md-diameter="20"></md-progress-circular>');

        $compile(circularProgressElement)(scope);

        var children = null;
        var cssWidth = element.prop('style')['width'];
        var width = null;
        if (!cssWidth) {
            (0, _jquery2.default)(element).css('width', width + 'px');
        }

        scope.$watch('circularProgress', function (newCircularProgress, prevCircularProgress) {
            if (newCircularProgress != prevCircularProgress) {
                if (newCircularProgress) {
                    if (!cssWidth) {
                        (0, _jquery2.default)(element).css('width', '');
                        width = element.prop('offsetWidth');
                        (0, _jquery2.default)(element).css('width', width + 'px');
                    }
                    children = (0, _jquery2.default)(element).children();
                    (0, _jquery2.default)(element).empty();
                    (0, _jquery2.default)(element).append((0, _jquery2.default)(circularProgressElement));
                } else {
                    (0, _jquery2.default)(element).empty();
                    (0, _jquery2.default)(element).append(children);
                    if (cssWidth) {
                        (0, _jquery2.default)(element).css('width', cssWidth);
                    } else {
                        (0, _jquery2.default)(element).css('width', '');
                    }
                }
            }
        });
    };

    return {
        restrict: "A",
        link: linker,
        scope: {
            circularProgress: "=tbCircularProgress"
        }
    };
}

/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/components/circular-progress.directive.js